import { values, pickBy } from 'lodash';
import createPollerMiddleware from '@blockcatio/tabby-library/lib/utilities/poller';
import retry from '@blockcatio/tabby-library/lib/utilities/retry';

import {
  createCampaignConfirmed,
  campaignEventsFetchFailed,
  campaignEventsFetched,
  discardCampaign,
  campaignsFetchFailed,
  campaignsFetched,
} from '../actions/campaigns';
import { CAMPAIGN_EVENTS_FETCHED, APP_SHUTDOWN, LATEST_BLOCK_NUMBER_UPDATED } from '../actionTypes';
import { CampaignStatuses } from '../constants';

const CampaignStatusesKeys = values(CampaignStatuses);
const getLocalCampaignsToDiscard = state =>
  values(pickBy(state.campaigns.localCampaigns, (localCampaign, transactionHash) => {
    const fetchedCampaign = state.campaigns.fetchedCampaigns[transactionHash];
    if (!fetchedCampaign) {
      return false;
    }
    const localStatus = CampaignStatusesKeys.indexOf(localCampaign.toString());
    const fetchedStatus = CampaignStatusesKeys.indexOf(fetchedCampaign.toString());
    return fetchedStatus > localStatus;
  }));

export default ({ tabbyRewards }) => (store) => {
  const { dispatch } = store;
  return createPollerMiddleware(store, {
    initialState: { lastBlock: 0 },

    frequency: 1000,

    checkStart: (action, nextState, prevState) =>
      nextState.account.address !== prevState.account.address,

    checkStop: action => action.type === APP_SHUTDOWN,

    checkRun: (pollerState, reduxState) =>
      reduxState.account.address && !reduxState.campaigns.isFetchingCampaigns,

    main: async (pollerState, reduxState) => {
      let { lastBlock } = pollerState;
      const { latestBlockNumber } = reduxState.app;

      // Start from the latest block after initial fetch or last run.
      if (latestBlockNumber > lastBlock) {
        lastBlock = latestBlockNumber;
      }

      try {
        const events = await retry(() => tabbyRewards.fetchEventsSince(lastBlock + 1));
        if (events.length) {
          dispatch(campaignEventsFetched(events));
          lastBlock = events.reduce(
            (maximum, event) => Math.max(maximum, event.blockNumber),
            lastBlock,
          );
        }
      } catch (error) {
        dispatch(campaignEventsFetchFailed(error));
      }

      return { lastBlock };
    },

    onAction: async (action) => {
      if (action.type === CAMPAIGN_EVENTS_FETCHED) {
        const { address } = store.getState().account;

        action.events.forEach((event) => {
          if (event.event === 'CampaignCreated' && event.returnValues.sender === address) {
            store.dispatch(createCampaignConfirmed(event));
          }
        });
      }

      // Fetch all campaigns only when we get the latest block number.
      if (action.type === LATEST_BLOCK_NUMBER_UPDATED) {
        const {
          account: { address },
          app: { latestBlockNumber: blockNumber },
        } = store.getState();
        if (address) {
          try {
            const campaigns = await retry(() => tabbyRewards.fetchCampaigns(address, blockNumber));
            dispatch(campaignsFetched(campaigns));

            getLocalCampaignsToDiscard(store.getState()).forEach((campaign) => {
              store.dispatch(discardCampaign(campaign.id));
            });
          } catch (error) {
            dispatch(campaignsFetchFailed(error));
          }
        }
      }
    },
  });
};



// WEBPACK FOOTER //
// ./src/middleware/pollCampaigns.js